/**
 * What regenerating a draft replaces, and what it changed. Pure, so the
 * draft toolbar only asks and reports.
 *
 * Regenerating reassigns every week of the draft from scratch, so a week
 * an admin changed by hand (marked "Set by admin") is replaced too. The
 * toolbar asks first when there are any, and says afterwards how many
 * weeks now have a different physician.
 */
import type { ISODate } from '../dates/iso.ts';

/** The weeks an admin changed by hand: reassigned, swapped, or given another special kind. */
export function handChangedWeeks(weeks: readonly { manual: boolean }[]): number {
  return weeks.filter((w) => w.manual).length;
}

interface Assignment {
  weekStart: ISODate;
  physicianId: string | null;
}

/**
 * How many weeks have a different physician after than before, matched by
 * the week's Monday. A week only in one of the two lists counts as changed.
 */
export function changedWeeks(before: readonly Assignment[], after: readonly Assignment[]): number {
  const was = new Map(before.map((w) => [w.weekStart, w.physicianId]));
  let changed = 0;
  for (const w of after) {
    if (!was.has(w.weekStart) || was.get(w.weekStart) !== w.physicianId) changed++;
    was.delete(w.weekStart);
  }
  return changed + was.size;
}
